import { useSessionContext } from '../../../context/session-context'
import { ImageFileId } from '../../image/image-file-id'
import { Skeleton } from 'src/component/ui/skeleton'

interface ProfileAvatarProps {
  size?: 'small' | 'medium' | 'large'
  className?: string
}

export const ProfileAvatar = (props: ProfileAvatarProps): React.ReactElement => {
  const { size = 'medium', className = '' } = props
  const { me } = useSessionContext()

  const sizeClasses = {
    small: 'w-[28px] h-[28px]',
    medium: 'w-[40px] h-[40px]',
    large: 'w-[100px] h-[100px]',
  }

  const avatarSize = sizeClasses[size]

  return (
    <div className={`${avatarSize} rounded-[4px] overflow-hidden ${className}`}>
      <ImageFileId fileId={me?.profile.profilePhotoFileId ?? ''} className="w-full h-full" />
    </div>
  )
}

export const ProfileUsername = (): React.ReactElement => {
  const { me } = useSessionContext()

  return (
    <p className="text-white font-evogria text-base font-medium">
      {me?.profile.username ? `HI, ${me?.profile.username?.toUpperCase()}` : <Skeleton className="h-6 w-24 bg-tertiary-grey" />}
    </p>
  )
}
